module.exports = __webpack_public_path__ + "img/icon-gallery.a116c995.svg";